import { Component, Inject, OnInit } from '@angular/core';
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { first, finalize } from 'rxjs';
import { HrDataService } from '../hr.service';
import { ToasterService } from 'src/app/services/core/toaster.service';
import { CoreService } from 'src/app/services/core/core.service';
import { DatePipe } from '@angular/common';
import {MatStepper} from "@angular/material/stepper";
import { ModuleDataMilestoneService } from 'src/app/services/module-data-milestone.service';

@Component({
    selector: 'app-staff-create-edit',
    templateUrl: './staff-create-edit.component.html',
    styleUrls: ['./staff-create-edit.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: false
})
export class StaffCreateEditComponent implements OnInit {
  public staffForm!: UntypedFormGroup;
  public step:any;
  public editData: any = null;
  public isEdit:boolean = false;
  public isSaving = false;

  /** Module id of the Staff module — used for milestone auto-deploy. */
  private readonly STAFF_MODULE_ID = 11;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StaffCreateEditComponent>,
    private hrDataService: HrDataService,
    public toasterService: ToasterService,
    public coreService: CoreService,
    public datePipe: DatePipe,
    private moduleDataMilestoneService: ModuleDataMilestoneService
  ) {
    this.editData = this.data.editData;
    this.isEdit = this.data.isEdit;
  }

  ngOnInit() {
    this.staffForm = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        staffInformation: new UntypedFormControl(null)
      }),
      step02: new UntypedFormGroup({
        staffDetail: new UntypedFormControl(null)
      }),
      step03: new UntypedFormGroup({
        staffAddress: new UntypedFormControl(null)
      }),
      step04: new UntypedFormGroup({
        salary: new UntypedFormControl(null)
      }),
      step05: new UntypedFormGroup({
        certifications: new UntypedFormControl(null)
      }),
    });
  }
  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};
  }
  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  initChildForm(step: string, formControlName: string, value:any){
    this.staffForm.get(step)?.get(formControlName)?.setValue(value);

  }


  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let staffForm = this.staffForm.get(formControlName);
                    // @ts-ignore
    staffForm = secondFormControlName ? staffForm?.get(secondFormControlName) : staffForm;
    staffForm?.markAsTouched()
    staffForm?.updateValueAndValidity({ onlySelf: false, emitEvent: true });

    if(!formControlName){
      this.staffForm?.disabled
    }

  }


  getFormData = () => {
    const formData: any = {
      hr_code: this.staffForm?.value?.step01?.staffInformation?.hr_code,
      first_name: this.staffForm?.value?.step01?.staffInformation?.first_name,
      last_name: this.staffForm?.value?.step01?.staffInformation?.last_name,
      email: this.staffForm?.value?.step01?.staffInformation?.email,
      password: this.staffForm?.value?.step01?.staffInformation?.password,
      can_login: this.staffForm?.value?.step01?.staffInformation?.can_login? 1 : 0,
      attach_tenents: this.staffForm?.value?.step01?.staffInformation?.attach_tenents?.map((tenant: any) => tenant?.id),
      current_tenent: this.staffForm?.value?.step01?.staffInformation?.current_tenent?.id,
      phone_number: this.staffForm?.value?.step02?.staffDetail?.phone_number,
      extension: this.staffForm?.value?.step02?.staffDetail?.extension,
      department: this.staffForm?.value?.step02?.staffDetail?.department?.id || this.editData?.staff_detail?.department,
      language: this.staffForm?.value?.step02?.staffDetail?.language?.name || this.editData?.staff_detail?.language,
      time_zone: this.staffForm?.value?.step02?.staffDetail?.time_zone?.zone || this.editData?.staff_detail?.time_zone,
      roles: this.staffForm?.value?.step02?.staffDetail?.roles?.map((role: any) => role.name) || [],
      supervisors: this.staffForm?.value?.step02?.staffDetail?.supervisors?.map((supervisor: any) => supervisor.id) || [],
      start_date: this.coreService.toMomentDate(this.staffForm?.value?.step02?.staffDetail?.start_date),
      birthday: this.coreService.toMomentDate(this.staffForm?.value?.step02?.staffDetail?.birthday),
      state_id: this.staffForm?.value?.step03?.staffAddress?.staff_address.state_id?.id || this.editData?.staff_detail?.id,
      address_line_1: this.staffForm?.value?.step03?.staffAddress?.staff_address.address_line_1,
      address_line_2: this.staffForm?.value?.step03?.staffAddress?.staff_address.address_line_2,
      city: this.staffForm?.value?.step03?.staffAddress?.staff_address.city,
      zipcode: this.staffForm?.value?.step03?.staffAddress?.staff_address.zipcode,
      salary: this.staffForm?.value?.step04?.salary?.salary,
      hourly_pay: this.staffForm?.value?.step04?.salary?.hourly_pay ? 1 : 0,
      id: this.editData?.id && this.editData?.id
    };

    // Only include certificates when creating (not editing)
    if (!this.isEdit) {
      formData.certificates = this.makeCertificatesData() || this.editData?.certificates;
    }

    return formData;
  }



  makeCertificatesData() {
    const certificateArray: any = [];
    const data = this.staffForm?.value?.step05?.certifications?.certificates;
    console.log('dru',data);
    data?.map((item: any) => {
      const value = {
        certificate_id: item?.id,
        file: item?.file_id,
        is_selected: item?.is_certified ? 1 : 0,
        expire_at: this.datePipe.transform(item?.expiration_date,'yyyy-MM-dd'),
      }
      certificateArray.push(value);
    })

    return certificateArray;
  }

  onSubmit() {

    if (this.isSaving) {
      return;
    }
    const isCreate = !this.editData;
    const service = this.editData ? this.hrDataService.updateStaffData(this.editData?.id, this.getFormData()) : this.hrDataService.createStaff(this.getFormData());
    this.isSaving = true;
    service
      .pipe(
        first(),
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: response => {
          if (isCreate) {
            const newStaffId = response?.data?.staff?.id;
            if (newStaffId) {
              this.autoDeployMilestones(newStaffId);
            }
          }
          this.close(response?.data);
          this.toasterService.showSuccessMessage(response?.data.message);
        },
        error: error => {
          const message = error?.error?.message || 'Unable to save staff. Please try again.';
          this.toasterService.showErrorMessage(message);
        }
      });
  }

  /**
   * After a staff member is created, attach the Staff module's auto-deploy milestone
   * template (if one is enabled). Fire-and-forget — failures are logged silently and
   * never block the create flow.
   */
  private autoDeployMilestones(staffId: number) {
    this.moduleDataMilestoneService
      .autoDeploy(this.STAFF_MODULE_ID, staffId)
      .pipe(first())
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Milestone auto-deploy failed for staff', staffId, err);
        }
      });
  }

  close = (data: any = '') => {
    this.dialogRef.close(data);
  }
}
